// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"n1-z","subtitle":"o1-z","wrapper":"p1-z","leftArrow":"q1-z","rightArrow":"r1-z"};